import api from './api';

const API_URL = '/crm/ai-planner';

const aiPlannerService = {
  /**
   * Generates a monthly marketing plan based on a topic prompt.
   * @param {string} topic
   */
  generatePlan: async (topic) => {
    const response = await api.post(`${API_URL}/generate`, { topic });
    return response.data;
  },

  /**
   * Bulk applies the generated tasks to the CRM.
   * @param {Array} tasks
   */
  applyPlan: async (tasks) => {
    const response = await api.post(`${API_URL}/apply`, { tasks });
    return response.data;
  }
};

export default aiPlannerService;
